import { z } from "zod";

/**
 * Schema for editing company details.
 *
 * Note: Most company fields are synced from Salesforce and are read-only.
 * Only fieldServiceSoftwareId and leadGenPaymentSourceType can be edited
 * through the Hub UI.
 */
export const editCompanySchema = z.object({
  fieldServiceSoftwareId: z.number().nullable().optional(),
  leadGenPaymentSourceType: z.enum(["ach", "card"]).nullable().optional(),
  leadGenCrid: z.string().nullable().optional(),
});

// Schema for syncing company from Salesforce
export const syncCompanyFromSalesforceSchema = z
  .object({
    intacctId: z.string().optional(),
    salesforceId: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (!!data.intacctId?.trim() || !!data.salesforceId?.trim()) {
      return;
    }

    const message = "Either Salesforce ID or Intacct ID is required.";

    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message,
      path: ["intacctId"],
    });

    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message,
      path: ["salesforceId"],
    });
  });

// Type inference
export type EditCompanyFormData = z.infer<typeof editCompanySchema>;
export type SyncCompanyFromSalesforceFormData = z.infer<
  typeof syncCompanyFromSalesforceSchema
>;
